import { statisticsConstants } from '../constants/statistics';
import { statistics, slaves } from '../services/ApiService';

export const setStatisticsTabs = tabs => ({
  type: statisticsConstants.SET_STATS_TABS_SUCCESS,
  tabs,
});

export const startSetStatisticsTabs = (template) => dispatch =>
  statistics
    .getTabs(template)
    .then(data => dispatch(setStatisticsTabs(data.items[0])))
    .catch(err => dispatch({ type: statisticsConstants.SET_STATS_TABS_FAILURE }));

export const setStatistics = data => ({
  type: statisticsConstants.SET_STATS_SUCCESS,
  data,
});

const getStatsMethod = ({type, params, isMembers, isMember}) => {
  if(!isMembers && !isMember) {
    return statistics.getStats(type, params);
  } else if(isMember) {
    return slaves.getSlave(type, params).then(({response}) => response);
  } else {
    return slaves.getSlavesStats(type, params).then(({response}) => response);
}
};

export const startSetStatistics = props => dispatch => {
  dispatch({ type: statisticsConstants.SET_STATS_REQUEST });
  return getStatsMethod(props)
    .then(data => dispatch(setStatistics(data)));
    // .catch(err => dispatch({ type: statisticsConstants.SET_STATS_FAILURE }));
};

export const setDictionary = (dictionary = {}) => ({
  type: statisticsConstants.SET_STATS_DICTIONARY_SUCCESS,
  dictionary,
});

export const startSetDictionary = (type, params) => dispatch => {
  return statistics
    .getDictionary(type, params)
    .then(data => dispatch(setDictionary({ [type]: data.items })))
    .catch(err => dispatch({ type: statisticsConstants.SET_STATS_DICTIONARY_FAILURE }));
};

export const setStatisticsFilters = filters => ({
  type: statisticsConstants.SET_STATS_FILTERS_SUCCESS,
  filters,
});

export const resetStatFilters = () => ({
  type: statisticsConstants.RESET_STATS_FILTERS,
});

export const setWebmasterPresets = (presets = []) => ({
  type: statisticsConstants.SET_WEBMASTER_PRESETS_SUCCESS,
  presets,
});

export const startSetWebmasterPresets = () => dispatch =>
  statistics.getWebmasterPresets().then((data = {}) => dispatch(setWebmasterPresets(data.items)));

export const createWebmasterPreset = ({ id }, filter) => ({
  type: statisticsConstants.CREATE_WEBMASTER_PRESET_SUCCESS,
  preset: { id, ...filter },
});

export const startCreateWebmasterPreset = filters => dispatch =>
  statistics
    .addWebmasterPreset(filters)
    .then(({ items = [] }) => dispatch(createWebmasterPreset(items[0], filters)))
    .catch(e => dispatch({ type: statisticsConstants.CREATE_WEBMASTER_PRESET_FAILURE }));

export const updateWebmasterPreset = (id, filter) => ({
  type: statisticsConstants.UPDATE_WEBMASTER_PRESET_SUCCESS,
  id,
  filter,
});

export const startUpdateWebmasterPreset = (id, filters) => dispatch =>
  statistics
    .updateWebmasterPreset(id, filters)
    .then(() => dispatch(updateWebmasterPreset(id, filters)))
    .catch(e => dispatch({ type: statisticsConstants.UPDATE_WEBMASTER_PRESET_FAILURE }));

export const removeWebmasterPreset = id => ({
  type: statisticsConstants.REMOVE_WEBMASTER_PRESET_SUCCESS,
  id,
});

export const startRemoveWebmasterPreset = id => dispatch =>
  statistics
    .removeWebmasterPreset(id)
    .then(() => dispatch(removeWebmasterPreset(id)))
    .catch(e => dispatch({ type: statisticsConstants.REMOVE_WEBMASTER_PRESET_FAILURE }));


export const setStatisticsCurrentTab = tab => dispatch => 
  dispatch({type: statisticsConstants.SET_CURRENT_TAB, tab});